<template>
  <div class="topup-back">
    <div class="text" v-if="isPaymentWaitingForStatus || isLoading">
      <h1 v-if="!isPaymentSourceBlik" v-html="$t('view.backCreditCard.titleVerify')"></h1>
      <p v-if="isPaymentSourceBlik" v-html="$t('view.backCreditCard.blikDescription')"></p>
      <p style="margin-top: 30px"><img src="../assets/images/ajax-loader-big.gif" alt=""></p>
    </div>
    <div v-if="!isPaymentWaitingForStatus && !isLoading">
      <div class="text" v-if="isPaymentOk">
        <h1 v-if="!isPaymentSourceBlik" v-html="$t('view.backCreditCard.title1')"></h1>
        <h1 v-if="isPaymentSourceBlik" v-html="$t('view.backCreditCard.title1a')"></h1>
        <p v-html="$t('view.backCreditCard.title2')"></p>
      </div>
      <div class="text" v-if="isPaymentError">
        <h1 v-html="$t('view.backCreditCard.titleError')"></h1>
      </div>
      <div class="button">
        <button type="button" @click="goToTopup">{{ $t('view.backCreditCard.buttonBack') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import CreditCardBackMixin from '@/common/mixins/views/CreditCardBack.mixin'

export default {
  name: 'CreditCardBackView',
  mixins: [CreditCardBackMixin]
}
</script>
